import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getChatWidth } from "../../ducks/chat/selectors";
import { setChatWidth } from "../../ducks/chat/chat";

export const useChatWidth = (): [number, (value: number) => void] => {
  const dispatch = useDispatch();
  const chatWidth = useSelector(getChatWidth);

  const update = useCallback(
    (value: number) => {
      dispatch(setChatWidth(value));
    },
    [dispatch],
  );

  return [chatWidth, update];
};
